import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    Modal, Paper, Typography,
    Grid, Button, Divider,
    List, ListItem, ListItemText, ListItemAvatar, ListItemSecondaryAction,
} from '@mui/material';
import { Avatar, } from 'antd';

import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import { changeIcon, selectVehicleById } from '../../features/assets/assetsSlice';
import { mapIcons } from '../../utils/iconFiles';

const ChangeIconModal = ({ changeIconOpen, handleChangeIconClose, assetId }) => {
    const dispatch = useDispatch();
    const dimention = useSelector(liveTrackinglayoutSelector);
    const assetData = useSelector(state => selectVehicleById(state, assetId));
    const initialIcon = assetData && assetData.vehicleDevice.icon;
    const regn = assetData && assetData.vehicleDevice.regn;
    const [icon, setIcon] = useState(initialIcon);

    useEffect(() => {
        setIcon(initialIcon);
    }, [assetId, initialIcon]);

    const handleSubmit = () => {
        dispatch(changeIcon({
            assetId,
            app_icon: icon
        }));
        handleChangeIconClose();
    }

    return (
        <Modal
            open={changeIconOpen}
            onClose={handleChangeIconClose}
        >
            <div style={{
                ...dimention.mapModal,
            }}>
                <Paper>
                    <Grid
                        container
                        spacing={4}
                        style={{
                            marginLeft: '5px',
                            marginRight: '5px',
                            width: '300px'
                        }}
                        alignItems="center"
                    >
                        <Grid item sm={12}>
                            <List dense>
                                <ListItem>
                                    <ListItemText
                                        primary={
                                            <Typography variant="h6"><b>Change Icon: {regn}</b></Typography>
                                        }
                                    />
                                </ListItem>
                                <Divider />
                                <br />
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar>
                                            <img alt={icon} src={`/assets/markers/def40/${icon}`} />
                                        </Avatar>
                                    </ListItemAvatar>

                                    <ListItemSecondaryAction>
                                        {
                                            icon !== initialIcon &&
                                            <Button variant="text" color="primary" onClick={handleSubmit}>Save</Button>
                                        }

                                        <Button variant="text" color="secondary" onClick={handleChangeIconClose}>Cancel</Button>
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <br />
                            </List>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={4}
                        style={{
                            marginLeft: '5px',
                            marginRight: '5px',
                            maxHeight: '400px',
                            overflow: 'auto'
                        }}
                        alignItems="center"
                    >
                        {
                            mapIcons.map(ic => (
                                <Grid item key={ic}>
                                    <Avatar style={{ backgroundColor: 'white' }} onClick={() => setIcon(ic)}>
                                        <Button><img alt={ic} src={`/assets/markers/def40/${ic}`} /></Button>
                                    </Avatar>
                                </Grid>
                            ))
                        }
                    </Grid>
                </Paper>
            </div>
        </Modal>
    );
}

export default ChangeIconModal;